<template>
  <div>
    <v-stepper v-if="resposta" class="elevation-1" v-model="currentStep" vertical>

      <v-stepper-step :complete="currentStep > 1" step="1">
        Produtos
      </v-stepper-step>
      <v-stepper-content step="1">
        <px-cotacao-conjunta-resposta-step-produtos
          :solicitacao="solicitacao"
          :resposta="resposta"
          :editing="editing"
          @next="next"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 2" step="2">
        Condições e frete
      </v-stepper-step>
      <v-stepper-content step="2">
        <px-cotacao-conjunta-resposta-step-condicoes-frete
          :resposta="resposta"
          @next="next"
          @previous="previous"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 3" step="3">
        Finalização
      </v-stepper-step>
      <v-stepper-content step="3">
        <px-cotacao-conjunta-resposta-finalizacao v-if="currentStep === 3"
                                                  :resposta="resposta"
                                                  :loading="loading"
                                                  @next="saveResposta"
                                                  @previous="previous"/>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import { SituacaoResposta } from 'px-business-components';
import { cloneDeep } from 'lodash';
import CotacaoConjuntaRespostaStepProdutos from './CotacaoConjuntaRespostaStepProdutos.vue';
import CotacaoConjuntaRespostaStepCondicoesFrete
  from './CotacaoConjuntaRespostaStepCondicoesFrete.vue';
import CotacaoConjuntaRespostaFinalizacao from './CotacaoConjuntaRespostaFinalizacao.vue';
import CotacaoConjuntaService from '../cotacao-conjunta-resposta.service';

export default {
  props: {
    solicitacao: Object,
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentStep: 1,
      loading: false,
      resposta: null,
    };
  },
  methods: {
    next() {
      this.currentStep += 1;
    },
    previous() {
      this.currentStep -= 1;
    },
    emitUpdate() {
      this.$emit('update');
    },
    buildToSave() {
      const resposta = cloneDeep(this.resposta);
      resposta.produtos = resposta.produtos.map((produto) => ({
        id: produto.id || undefined,
        cotacaoConjuntaProduto: {
          id: produto.cotacaoConjuntaProduto.id,
        },
        situacao: produto.situacao,
        prazos: produto.prazos,
        especificacaoProduto: produto.especificacaoProduto,
        impostos: produto.impostos,
        arquivos: produto.arquivos,
      }));
      return resposta;
    },
    saveResposta() {
      this.loading = true;
      CotacaoConjuntaService.responder(this.buildToSave())
        .then(() => {
          this.$toast('Resposta enviada', { color: 'success' });
          this.emitUpdate();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.editing) {
      this.resposta = this.solicitacao.respostaCotacaoConjunta;
      return;
    }
    this.resposta = {
      fornecedor: {
        id: this.solicitacao.fornecedor.id,
      },
      cotacaoConjunta: {
        id: this.solicitacao.cotacaoConjunta.id,
      },
      situacao: SituacaoResposta.keys.RESPONDIDA.key,
      validade: null,
      observacao: null,
      frete: {
        tipoFrete: null,
        totalTransporte: 0,
        observacaoFrete: null,
        prazoEntrega: null,
        valorMinimoFreteGratis: null,
        ofertaFreteGratis: null,
      },
      produtos: [],
    };
  },
  components: {
    pxCotacaoConjuntaRespostaStepProdutos: CotacaoConjuntaRespostaStepProdutos,
    pxCotacaoConjuntaRespostaStepCondicoesFrete: CotacaoConjuntaRespostaStepCondicoesFrete,
    pxCotacaoConjuntaRespostaFinalizacao: CotacaoConjuntaRespostaFinalizacao,
  },
};
</script>
